<script lang="ts">
    import PanelistMeetingPage from '@Evaluation/Estimations/Pages/PanelistMeetingPage'
    export default PanelistMeetingPage
</script>

<template>
    <div>
        <AlternativeDetailsDialog :viewModel="alternativeDetailsDialog" />
        <AttributeDescriptionDialog :viewModel="attributeDescriptionDialog" />

        <div v-if="!Initialized || Connecting" class="d-flex justify-content-center" style="padding-top: 200px;">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title"><i class="fa fa-spinner fa-spin"></i> Connecting...</h5>
                    <p class="card-text lead">We are checking if meeting was started by the host.</p><br />
                </div>
            </div>
        </div>

        <div v-if="Initialized && !Connecting && !MeetingStarted" class="d-flex justify-content-center" style="padding-top: 200px;">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Meeting is not started</h5>
                    <p class="card-text lead">Please wait for the host to start this meeting.</p><br />
                    <a class="btn btn-secondary" v-sanitizedHref="DashboardUrl">Go to the survey mode</a>
                </div>
            </div>
        </div>

        <div v-if="Initialized && !Connecting && MeetingStarted && EligibleQuestion">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div class="container">
                    <a class="btn btn-light mr-auto" v-sanitizedHref="DashboardUrl">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        My Survey
                    </a>
                </div>
            </nav>
            <div class="container" style="padding-top: 80px;">
                <div id="MeetingQuestion">
                    <div style="min-height: 100vh; margin-top: 80px;">
                        <p class="text-center lead" style="font-size: 1.5rem;">
                            How would you rate: <a class="text-primary" title="Show description" @click="ShowAlternativeDetailsCommand">{{AlternativeName}}</a><br />
                            in the context of: <a class="text-primary" title="Show description" @click="ShowAttributeDetailsCommand">{{AttributeName}}</a>?
                        </p>

                        <div style="min-height: 450px;">
                            <PanelistVoteEditor :comment="voteComment"
                                                :value="voteValue"
                                                :scaleLevels="Question.ScaleLevels"
                                                @update-comment="handleUpdateComment"
                                                @update-value="handleUpdateValue" />
                        </div>


                        <div v-if="Question?.Entries != null" class="mt-4" style="min-height: 500px;">
                            <VotesBrowser :AlternativeName="Question.AlternativeName"
                                        :HasScale="Question.HasScale"
                                        :Entries="Question.Entries"
                                        :ScaleLevels="Question.ScaleLevels" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="Initialized && !Connecting && MeetingStarted && !EligibleQuestion">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div class="container">
                    <a class="btn btn-light mr-auto" v-sanitizedHref="DashboardUrl">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        My Survey
                    </a>
                </div>
            </nav>
            <div class="container" style="padding-top: 80px;">
                <div id="MeetingQuestion">
                    <div style="min-height: 100vh; margin-top: 80px;">


                        <div class="d-flex justify-content-center">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Sorry, you are not selected to answer this question.</h5>
                                    <p class="card-text lead">Please wait for another question.</p>

                                    <!--<p>
                                    How would you rate: <a class="text-primary" title="Show description" @click="ShowAlternativeDetailsCommand">{{AlternativeName}}</a>
                                    in the context of: <a class="text-primary" title="Show description" @click="ShowAttributeDetailsCommand">{{AttributeName}}</a>?
                                </p>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    iv
                </div>
            </div>
        </div>
    </div>
</template>
